import { SubProductAction } from "features/product/types/actions.subproduct";
import { PropertyType } from "features/product/types/subproduct";
import { TableColumn } from "features/product/types/subproductTable";
import React from "react";
import { useCallback } from "react";
import {
    BiFile,
    BiHide,
    BiImage,
    BiShow,
    BiStar,
    BiText,
    BiTrash,
} from "react-icons/bi";
import { useDispatch } from "services/redux/rootReducer";
import {
    DangerIconContainer,
    Divider,
    IconContainer,
    MutedIconContainer,
    StyledTooltipMenu,
} from "./header.styled";

interface Props {
    propertyColumn: TableColumn;
    idx: number;
}

const TooltipMenu: React.FC<Props> = ({ propertyColumn, idx }) => {
    const dispatch = useDispatch();

    const getDisplayedTypeIcon = useCallback((propertyType: PropertyType) => {
        switch (propertyType) {
            case PropertyType.Text:
                return <BiText />;
            case PropertyType.FileDownload:
                return <BiFile />;
            case PropertyType.Image:
                return <BiImage />;
            case PropertyType.PromotionTags:
                return <BiStar />;
            default:
                return null;
        }
    }, []);

    const handleTypeChange = (propertyType: PropertyType) => {
        if (
            !window.confirm(
                `Are you sure you would like to change type to ${propertyType}? Proceeding will erase all cell values.`
            )
        )
            return;
        dispatch({
            type: SubProductAction.ASSIGN_PROPERTY,
            propertyColumn: {
                ...propertyColumn,
                type: propertyType,
            },
        });
    };

    const handleToggleHide = () => {
        dispatch({
            type: SubProductAction.TOGGLE_COLUMN_SHOWN,
            idx,
        });
    };

    const handleDeleteProperty = () => {
        if (
            !window.confirm(
                `Are you sure you would like to delete this column?`
            )
        )
            return;
        dispatch({
            type: SubProductAction.REMOVE_PROPERTY,
            accessor: propertyColumn.accessor,
            idx,
        });
    };

    const displayedIcons = Object.values(PropertyType).map((propertyType) => {
        const Icon = () => getDisplayedTypeIcon(propertyType);
        const isSelected = propertyColumn.type === propertyType;
        return (
            <IconContainer
                key={propertyType}
                onClick={() => !isSelected && handleTypeChange(propertyType)}
                isSelected={isSelected}
            >
                <Icon />
            </IconContainer>
        );
    });

    return (
        <StyledTooltipMenu>
            {displayedIcons}
            <Divider />
            <MutedIconContainer onClick={handleToggleHide}>
                {propertyColumn.isHidden ? <BiHide /> : <BiShow />}
            </MutedIconContainer>
            <Divider />
            <DangerIconContainer onClick={handleDeleteProperty}>
                <BiTrash />
            </DangerIconContainer>
        </StyledTooltipMenu>
    );
};

export default TooltipMenu;
